// Cspell: disable

export const defaultConfig = {
  accounts: {
    authCallbackUrl: process.env.STORYBOOK_AUTH_CALLBACK_URL ?? "",
    host: process.env.STORYBOOK_SCMP_ACCOUNT_HOST ?? "",
    registerCallbackUrl: process.env.STORYBOOK_REGISTER_CALLBACK_URL ?? "",
  },
  corporateSubscriber: {
    host: process.env.STORYBOOK_CORPORATE_SUBSCRIBER_HOST ?? "",
  },
  environment: "dev" as "dev" | "production",
  facebook: {
    appId: "282931841805811",
    likeUrl: process.env.STORYBOOK_FACEBOOK_LIKE_URL ?? "",
  },
  graphql: {
    apiKey: process.env.STORYBOOK_CONTENTSERVICE_APIKEY ?? "",
    host: process.env.STORYBOOK_CONTENTSERVICE_HOST ?? "",
  },
  newsletter: {
    globalImpact: "506194",
    lunar: "501957",
    postMag: "322743",
    thisWeekInAsia: "323063",
  },
  notification: {
    // No need to take from environment since it's being mocked
    host: "",
  },
  recaptcha: {
    siteKey: process.env.STORYBOOK_RECAPTCHA_SITE_KEY ?? "",
  },
  siteUrl: process.env.STORYBOOK_SITE_URL ?? "",
  subscribe: {
    host: process.env.STORYBOOK_ROSETTA_HOST ?? "",
  },
  twitter: {
    accountName: "SCMPnews",
  },
};

export type GeneralConfig = typeof defaultConfig;
